import { SlidersHorizontal } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "../../../../components/ui/common/button";
import { Checkbox } from "../../../../components/ui/common/checkbox";
import { Label } from "../../../../components/ui/common/label";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "../../../../components/ui/common/popover";
import { FACILITY_TYPES } from "../../../../config/constants";
import { getFacilityFilter, saveFacilityFilter } from "../../../../utils/cacheStorage";
import { FacilityTypeFilterPanelProps } from "../types/facilityList.types";

export const FacilityTypeFilterPanel = ({ refetchWithFilters }: FacilityTypeFilterPanelProps) => {
  const [open, setOpen] = useState(false);
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);

  useEffect(() => {
    setSelectedTypes(getFacilityFilter());
  }, []);

  const toggleType = (value: string) => {
    setSelectedTypes(prev =>
      prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
    );
  };

  const handleReset = () => {
    setSelectedTypes([]);
    saveFacilityFilter([]);
    refetchWithFilters([]);
    setOpen(false);
  };

  const handleApply = () => {
    saveFacilityFilter(selectedTypes);
    refetchWithFilters(selectedTypes);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="tw-shrink-0 tw-gap-2">
          <SlidersHorizontal size={16} />
          Filters
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="tw-w-72">
        <div className="tw-flex tw-flex-col tw-gap-4">
          <div className="tw-flex tw-flex-col tw-gap-2">
            <p className="tw-text-sm tw-font-medium tw-text-foreground">Facility Type</p>
            {FACILITY_TYPES.map(option => (
              <label
                key={option.value}
                className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-text-sm tw-text-foreground"
              >
                <Checkbox
                  checked={selectedTypes.includes(option.value)}
                  onCheckedChange={() => toggleType(option.value)}
                />
                <Label className="tw-cursor-pointer tw-text-sm tw-font-normal">{option.text}</Label>
              </label>
            ))}
          </div>
          <div className="tw-flex tw-justify-end tw-gap-2 tw-border-t tw-border-border tw-pt-3">
            <Button variant="outline" size="sm" onClick={handleReset}>
              Reset
            </Button>
            <Button size="sm" onClick={handleApply}>
              Apply
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
